import {
  AdminCaseApi,
  type CaseCreateDTO,
  type CaseUpdateDTO,
  type Discharge,
  type PaginatedCaseWithPatientV3,
  type PatientWithOptionalCaseResponse
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class AdminPatientsService {
  static readonly adminPatientsApi = new AdminCaseApi(globalApiConfig)

  static async getPatientsByHospitalId(
    hospitalIds: string[],
    offset: number,
    limit: number
  ): Promise<PaginatedCaseWithPatientV3> {
    return (
      await AdminPatientsService.adminPatientsApi.getCasesByHospitalId(hospitalIds, offset, limit)
    ).data
  }

  static async createPatient(patient: CaseCreateDTO): Promise<void> {
    await AdminPatientsService.adminPatientsApi.createCase(patient)
  }

  static async updatePatient(patient: CaseUpdateDTO): Promise<void> {
    await AdminPatientsService.adminPatientsApi.updateCase(patient.caseId, patient)
  }

  static async importPatients(file: File): Promise<void> {
    await AdminPatientsService.adminPatientsApi.importCasesFromCSV(file)
  }

  static async getPatientWithOptionalCaseByExternalId(
    patientNumber: string
  ): Promise<PatientWithOptionalCaseResponse> {
    return (await AdminPatientsService.adminPatientsApi.getPatientWithOptionalCase(patientNumber))
      .data
  }

  static async closeCase(caseId: string, reason: Discharge): Promise<void> {
    await AdminPatientsService.adminPatientsApi.archiveCase(caseId, reason)
  }
}
